import { OgCustomInputsModule } from 'projects/og-custom-inputs/src/public_api';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import { MatFormFieldControl } from '@angular/material';
import { Component, OnInit, forwardRef, OnDestroy, Input, Optional, Self, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, NgControl, FormBuilder, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { FocusMonitor } from '@angular/cdk/a11y';
import { OgCustomInput } from '../OgCustomInput';
import { timeMaskPipe } from '../mask-pipes';
export function validarHorario(c: FormControl) {
  const err = {
    horario: {
      valid: false
    }
  };
  return /^(([01][0-9])|(2[0-3])):[0-5][0-9]$/.test(c.value) ? null : err;
}
@Component({
  selector: 'og-horario-input',
  template: `<ng-container *ngIf="isMaterialFormField; else elseTemplate">
  <input type="text" matInput [textMask]="timeMask" [placeholder]="placeholder" [disabled]="disabled"
    [value]="value" (change)="onChange($event)" (keyup)="keyUp($event)">
</ng-container>
<ng-template #elseTemplate>
  <input type="text" [textMask]="timeMask" [placeholder]="placeholder" [disabled]="disabled"
    [value]="value" (change)="onChange($event)" (keyup)="keyUp($event)">
  <div class="form-error" ogDefaultFormErrors></div>
</ng-template>
`,
  styles: [``],
  providers: [{provide: MatFormFieldControl, useExisting: OgHorarioInputComponent}],
})
export class OgHorarioInputComponent extends OgCustomInput implements MatFormFieldControl<String>, ControlValueAccessor, OnInit, OnDestroy {
  static nextId = 0;
  controlType = 'og-horario-input';
  id = `og-horario-input-${OgHorarioInputComponent.nextId++}`;
  autofilled?: boolean;
  public timeMask;

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    protected fm: FocusMonitor,
    protected elRef: ElementRef
  ) {
    super(ngControl, fm, elRef);
    this.timeMask = {
      mask: [/\d/, /\d/, ':', /\d/, /\d/],
      keepCharPositions: true,
      pipe: timeMaskPipe,
    };
  }

  keyUp(event: KeyboardEvent) {
    this.propagateTouch(event);
    this.onChange(event);
    this.checkErrorState();
  }

}
